import { Conversation } from '../conversation';
import * as moment from 'moment';

export class ConversationVM {
  id?: number;
  name?: string;
  accountName?: string;
  moduleName?: string;
  moduleRecord?: string;
  moduleRecordName?: string;
  email?: string;
  phone?: any[];
  internalPhoneNo?: string;
  status?: string;
  unreadMessageCount?: number;
  createDate?: string;
  lastMessage?: {
    text: string;
    type: string;
    status: string;
    reply : string;
  };
  subscribed?: boolean;
  expired?: boolean;

  static toVM(conversation: Conversation) {
    const lastMessage = conversation?.lastMessage;
    const subscribed = conversation?.group?.lastExternalMessageDate == null ? true : conversation?.subscribed;
    let isExpired:boolean = conversation?.group?.lastExternalMessageDate == null ? true : this.isExpired(conversation?.group?.lastExternalMessageDate);
    return {
      id: conversation?.group?.id ?? '',
      name: conversation?.externalMember?.contactName ?? 'Unknown',
      accountId: conversation?.externalMember?.accountId ?? '',
      accountName: conversation?.externalMember?.accountName ?? 'Unknown',
      moduleName: conversation?.externalMember?.moduleName ?? 'Unknown',
      moduleRecordName: conversation?.externalMember?.moduleRecordName ?? '',
      image: '',
      phone: [{ phone: conversation?.externalMember?.phoneNumber ?? '' }],
      internalPhoneNoId: conversation?.group?.internalPhoneNoId ?? '',
      internalPhoneNo: conversation?.internalMember?.phoneNumber ?? '',
      status: conversation?.group?.isActive ? 'Active' : 'Pending',
      createDate: conversation?.group?.createdDate ?? '',
      unreadMessageCount: conversation?.group?.unreadMessageCount,
      lastMessageDateTime: conversation?.group?.lastMessageDateTime,
      lastExternalMessageDate: conversation?.group?.lastExternalMessageDate,
      messages: [],
      lastMessage: {
        text: lastMessage?.content,
        type: lastMessage?.messageType,
        status: this.deliveryStatus(lastMessage),
        reply: lastMessage?.reply || null,
      },
      subscribed: subscribed,
      expired: isExpired,
      contactType: conversation?.externalMember?.contactType,
    };
  }

    static deliveryStatus(m) {
        if (m?.statusFailed) return 'failed';
        if (m?.statusRead) return 'read'
        if (m?.statusDelivered) return 'delivered';
        if (m?.statusSent) return 'sent';
        return 'pending';
    }

  static isExpired(date: string): boolean {
    if (!date) return true;
    const pastDate = moment(date);
    const hoursDifference = moment().diff(pastDate, 'hours');
    return hoursDifference > 24;
  }
}
